module.exports = __webpack_public_path__ + "static/media/us.2e9ea4b0.svg";